export enum StoreSettings {
  ON_PREMISE_CONNECTIVITY_METHOD = 'onPremiseConnectivityMethod',
  ON_PREMISE_PAYMENT_PROVIDER = 'onPremisePaymentProvider',
  SHOW_RACK_DETAILS_IN_LIVE_LINK = 'showRackDetailsInLiveLink',
  TABLET_BRAND = 'tabletBrand',
  TIME_ZONE = 'timeZone',
  TRANSPORTATION_PREFERENCE = 'transportationPreference',
  TURN_AROUND_IN_HOURS = 'turnAroundInHours',
}

/**
 * Strategies for pickup and return delivery scheduling
 */
export enum TransportationPreferences {
  /**
   * For return delivery, sets the closest time window after pickup,
   * taking into account buffer time and turn around time.
   * The customer has the possibility to select any other window.
   */
  STANDARD = 'STANDARD',
  /**
   * For return delivery, sets the closest time window after pickup,
   * taking into account buffer time and turn around time,
   * and does not allow the customer to select any other window for return delivery.
   * In OOBO/MOBO, the operator is able to select the return delivery window himself.
   */
  AUTO_SCHEDULE = 'AUTO_SCHEDULE',
  /**
   * By default, return delivery is set as an empty value,
   * (no return delivery) when scheduling.
   */
  TEXT_WHEN_READY = 'TEXT_WHEN_READY',
}

export const DELIVERY_PREFERENCES = [
  { display: 'Standard', value: TransportationPreferences.STANDARD },
  { display: 'Auto Schedule Return Delivery', value: TransportationPreferences.AUTO_SCHEDULE },
  { display: 'Text when ready', value: TransportationPreferences.TEXT_WHEN_READY },
];
